const { products } = require('../../../constants');

export const CANCELLATION_STAGES = {
  COOLING_OFF: 'COOLING_OFF',
  CONFIRM_CANCEL: 'CONFIRM_CANCEL',
  RESULT: 'RESULT',
  ERROR: 'ERROR',
};

export const CANCELLATION_TYPES = {
  DEFERRED: 'deferred',
  IMMEDIATE: 'immediate',
};

const creditExpertBenefits = [
  'Daily score and report updates',
  'Detailed view of your score timeline',
  'What impacts your score',
  'Actions to improve your score',
];

const identityBenefits = [
  'Dedicated fraud support',
  'Daily online check for stolen details',
  'Steps to help protect your identity',
  'Lock your credit report to keep it safe',
];

export const DeferredCancelHappensNext = nextBillingDate => [
  `You’ll still have access to your benefits until ${nextBillingDate}`,
  'We’ll stop future payments',
  `We’ll move you to a free account on ${nextBillingDate}`,
];

export const ImmediateCancelHappensNext = [
  'You’ll lose access to your benefits today and move to a free account',
  'We’ll stop future payments',
  'You’ll get a refund within 14 days',
];

export const getBenefits = currentSubscription =>
  currentSubscription === products.credit_expert ? creditExpertBenefits : identityBenefits;

export const getSubscriptionName = currentSubscription =>
  currentSubscription === products.credit_expert ? 'CreditExpert' : 'Identity Plus';

export const formatDateToReadable = dateString => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};
